import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b5cfc5a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4b5cfc5a&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=4b5cfc5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5cfc5a",
  null
  
)

export default component.exports